// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"7e1333d1","268":"17aecf4d","787":"23fd5e31"}[chunkId] + ".chunk.js";
};